module.exports = __webpack_public_path__ + "img/plate02_05.ca3d57bb.png";